import { MenuList } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import { fetchContent } from 'client/modules/Content/ContentActions';
import React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid/dist/react-flexbox-grid';
import { useLoaderData } from 'react-router';
import { Link } from 'react-router-dom';
import Layout from '../../../App/components/Layout/LayoutContainer';

import styles from './LegalPage.css';

function LegalPage() {
  const { value } = useLoaderData();
  return (
    <Layout>
      <Grid className={styles['main-grid']}>
        <Row>
          <Col xs={12} sm={4} md={3} lg={3} style={{ position: 'relative', paddingRight: '15px' }}>
            <Paper sx={{ position: 'sticky', top: 100, mb: 4 }}>
              <MenuList>
                <MenuItem component={Link} to="/legal/terms">
                  Terms of Service
                </MenuItem>
                <MenuItem component={Link} to="/legal/privacy">
                  Privacy Policy
                </MenuItem>
                <MenuItem component={Link} to="/legal/dpa">
                  Data Processing Agreement
                </MenuItem>
                <MenuItem component={Link} to="/legal/cookies">
                  Cookie Policy
                </MenuItem>
              </MenuList>
            </Paper>
          </Col>
          <Col xs={12} sm={8} md={9} lg={9} style={{ paddingLeft: '15px', marginBottom: '30px' }}>
            <div dangerouslySetInnerHTML={{ __html: value }} />
          </Col>
        </Row>
      </Grid>
    </Layout>
  );
}

LegalPage.loader =
  ({ dispatch }) =>
  ({ params: { key } }) => {
    return dispatch(fetchContent(key));
  };

export default LegalPage;
